module.exports = __webpack_public_path__ + "img/hc_pro_one_1.a11e40e7.jpg";